export const getCostAvoided = (report, costSavingSettings) => {
  if (!costSavingSettings && !report) {
    return 0;
  }

  const costSavingMinValue = +costSavingSettings?.min_value || 0;
  const multiFactor = +report?.multiplication_factor || 0;
  const lphAvoided = +report?.lph_avoided || 0;
  const equipmentLaborSaving = +report?.equipment_labor_saving || 0;
  const downtimeAvoided = +report?.downtime_avoided || 0;

  if (!+costSavingSettings.use_lph_avoided) {
    return equipmentLaborSaving;
  }

  if (lphAvoided >= costSavingMinValue) {
    return (multiFactor * lphAvoided).toFixed(2);
  }

  if (downtimeAvoided >= costSavingMinValue) {
    return (multiFactor * downtimeAvoided).toFixed(2);
  }
};
